import webpack from "@/config/brands/webpack";

describe("WebPack Tests", () => {
  test("ofertaDigital should have adobeTargetActive as true", () => {
    expect(webpack.ofertaDigital.adobeTargetActive).toBe(true);
  });

  test("ofertaReferidor should have adobeTargetActive as false", () => {
    expect(webpack.ofertaReferidor.adobeTargetActive).toBe(false);
  });

  test("ofertaReferidorEmprendedores should have adobeTargetActive as false", () => {
    expect(webpack.ofertaReferidorEmprendedores.adobeTargetActive).toBe(false);
  });

  test("ofertaReferidosEmprendedores should have adobeTargetActive as false", () => {
    expect(webpack.ofertaReferidosEmprendedores.adobeTargetActive).toBe(false);
  });
});
